import {
    IClientFieldValue,
    IProps,
    IRef,
} from './types';

import classNames from 'classnames';
import React, {
    forwardRef,
    useImperativeHandle,
    useState,
} from 'react';

import {
    useRefsArray,
} from 'tools/hooks';

import {
    PrimaryButton,
} from 'components/buttons';
import {
    ErrorMessage,
} from 'components/other';

import StageCard from '../StageCard';

import ClientFieldValueInput, {
    IClientFieldInputRef,
} from './ClientFieldValueInput';

import styles from './ClientFieldsValuesInput.module.scss';

const ClientFieldsValuesInput = forwardRef<IRef, IProps>((props, ref) => {
    const [error, setError] = useState<string | null>(null);

    const {refs, validateRefs, extractRefs} = useRefsArray<IClientFieldValue, IClientFieldInputRef>(props.clientFields.map((clientField) => ({
        key: clientField.key,
        value: '',
    })));

    useImperativeHandle(ref, () => {
        return {
            getValue(): IClientFieldValue[] {
                return extractRefs();
            },
            validate(): boolean {
                return validateRefs();
            },
            setError(error: string | null): void {
                setError(error);
            },
        };
    });

    return (
        <StageCard
            className={classNames(styles.clientFieldsValuesInput, props.className)}
            number={2}
            title={props.clientFieldsBlockHint.title}
            description={props.clientFieldsBlockHint.description}
        >
            <div className={styles.list}>
                {
                    refs.map((ref, i) =>
                        <ClientFieldValueInput
                            key={i}
                            ref={refs[i]}
                            clientField={props.clientFields[i]}
                            isDisabled={props.isDisabled}
                        />
                    )
                }
            </div>
            <ErrorMessage
                className={styles.errorMessage}
                text={error}
            />
            <PrimaryButton
                className={styles.submitButton}
                text={'Submit'}
                isDisabled={props.isDisabled}
                onClick={props.onSubmit}
            />
        </StageCard>
    );
});

export default ClientFieldsValuesInput;
